import {Component, DestroyRef, Inject, inject, OnInit} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {DubletteSnackbar} from '../../../interfaces/dublette-snackbar.interface';
import {Store} from '@ngrx/store';
import {DubletteActions} from '../../../store/actions/dublette.actions';
import {InhaberDTO} from '../../../openapi/beleg-openapi';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AppState} from '../../../store/states/app.state';
import {ButtonModule, NavigationService} from '@adnova/jf-ng-components';

@Component({
  selector: 'app-dublette-snackbar',
  templateUrl: './dublette-snackbar.component.html',
  styleUrls: ['./dublette-snackbar.component.scss'],
  standalone: true,
  imports: [ButtonModule],
})
export class DubletteSnackbarComponent implements OnInit {
  private _store = inject(Store<AppState>);
  private _destroyRef = inject(DestroyRef);
  private _navigationService = inject(NavigationService);

  protected inhaberDto?: InhaberDTO;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: DubletteSnackbar) {}

  ngOnInit() {
    this._navigationService.inhaberList$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(inhaberDtos => {
      const inhaberDto = inhaberDtos.find(inhaberDto => inhaberDto.id === this.data.inhaberId);

      if (!inhaberDto) return;

      this.inhaberDto = inhaberDto;
    });
  }

  openDublettenDialog(): void {
    const dublettenIds = [this.data.belegId].concat(this.data.dublettenIds);
    this._store.dispatch(
      DubletteActions.openHandleDubletteDialog({
        inhaberId: this.inhaberDto!.id,
        dublettenIds,
      }),
    );
  }
}
